<template>
    <Modal  v-model="show" :mask-closable="false">
        <div slot="header" class="modal-header">录入表示数</div>
        <Form :model="initData" :rules="dataRules" ref="formEle"  :label-width="100">
            <FormItem label="设备状态：">
                 <span :class="{'online':initData.onoffLine === 1,'offline':initData.onoffLine === 2}">{{initData.onoffLine | formatOnoffLine}}</span>
            </FormItem>
            <FormItem label="设备示数：" prop="meterReading">
                <span v-if="hide">{{initData.meterReading}}m³</span>
                <Input class="input-width" v-model="initData.meterReading" v-else></Input>
            </FormItem>
            <FormItem label="抄表时间：">
                 <span>{{curTime}}</span>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="text" @click="cancel">取消</Button>
            <Button type="primary" @click="save" v-if="readstatus === 1" :loading="loading">
                <span v-if="!loading">确定</span>
                <span v-else>确定</span>
            </Button>
        </div>
    </Modal>
</template>
 
<script type="text/ecmascript-6">
import { getReadReal, readSave,permissinTest } from "api/meterReading";
import { formatDateTime } from "@/utils/format";
export default {
    props:{
        n:{
            type:Number,
            default:0
        },
        projectfid:{
            type:String,
            default:""
        },
        roomfid:{
            type:String,
            default:""
        },
        deivcetype:{
            type:Number,
            default:null
        },
        readingfid:{
            type: String,
            default: null
        },
        readstatus:{
            type: Number,
            default: null
        }
    },
    watch: {
        n() {
            this.initForm();
            this.initReal();
        },
    },
    data () {
        const validateMeterReading = (rule, value, callback) => {
            if(value === ""){
                callback(new Error('设备示数不能为空') )
            }else{
                value = Number(value);
                if(isNaN(value)){
                   callback(new Error('请输入正确的设备示数') ) 
                }else if(value <= 0){
                     callback(new Error('设备示数不能小于0') ) 
                }else{
                    callback()
                }
            }

        }
        return {
            show:false,
            loading:false,
            hide:false,
            params:{
                deviceType:"",
                meterReading:null,
                projectFid:"",
                readTime:"",
                readingFid:"",
                roomFid:"",
                value:null, //是否手动输入，0否1是
                
            },
            initData:{
                meterReading:null,
                onoffLine:null,
                readTime:"",
                projectFid:"",
                roomFid:""
            },
            dataRules:{
                meterReading:[
                    { validator: validateMeterReading, trigger: 'blur'}
                ]
            }
        }
    },
    computed: {
        curTime() {
            if(!this.initData.readTime){
                return  this.initData.readTime = formatDateTime(new Date());
            }else{
                return this.initData.readTime
            }
        }
    },
    methods: {
        initReal() {
            permissinTest.request({projectFid:this.projectfid,roomFid:this.roomfid,deviceType:this.deivcetype}).then(res => {
                if(res.data.meterReading){
                    this.hide = true;
                    this.params.value = 0;  
                }else{
                    this.hide = false;
                    this.params.value = 1;
                }
               this.initData = res.data;
               this.initData.deviceType = this.deivcetype;
               this.initData.readingFid = this.readingfid;
               console.log(this.initData)
               this.show = true;
            }) 
        },
        cancel() {
            this.show = false
        },
        toParams() {
            Object.keys(this.params).forEach(item => {
                if(this.initData[item] !== undefined){
                    this.params[item] = this.initData[item]
                }
            })
        },
        changeLoading(){
            this.loading = true;
            this.$nextTick(() => {
                this.loading = false
            })
        },
        save() {
            this.$refs['formEle'].validate( bool => {
                if(bool){
                    this.toParams();
                    readSave(this.params).then(res => {
                        this.$Message.success('保存成功');
                        this.show = false;
                        this.$emit('refresh')
                    })
                }
            })
        },
        initForm() {
            this.$refs['formEle'].resetFields();
        }
    }
}
</script>
<style scoped>
.input-width{
    width: 200px;
}
</style>
